import { IMapMarker, LatLng } from "../map-provider.interface";

type HereModule = typeof import('@here/maps-api-for-javascript');

type HereMap = InstanceType<HereModule["Map"]>;
type HereUtilEvent = InstanceType<HereModule["util"]["Event"]>;
type HereMapObject = InstanceType<HereModule["map"]["Object"]>;

export class HereMarker implements IMapMarker {
    private readonly _map: HereMap;
    private readonly _marker: HereMapObject;

    private _tapHandler: ((evt: HereUtilEvent) => void) | null = null;

    constructor(map: HereMap, marker: HereMapObject) {
        this._map = map;
        this._marker = marker;
    }

    remove(): void {
        this._map.removeObject(this._marker);
    }

    onClick(handler: () => void): void {
        // Replace any existing handler so we don't stack handlers
        if (this._tapHandler) {
            this._marker.removeEventListener("tap", this._tapHandler);
            this._tapHandler = null;
        }

        this._tapHandler = () => handler();
        this._marker.addEventListener("tap", this._tapHandler);
    }

    getPosition(): LatLng {
        // Geometry is typically an H.geo.Point-like object { lat, lng }
        const p = (this._marker as any).getGeometry?.() as { lat: number; lng: number } | undefined;
        if (!p)
            return { lat: 0, lng: 0 };

        return { lat: p.lat, lng: p.lng };
    }

    setPosition(coords: LatLng): void {
        // Marker can be H.map.Marker or H.map.DomMarker
        (this._marker as any).setGeometry?.(coords);
    }

    _native(): HereMapObject {
        return this._marker;
    }
}